import React, { useState, useEffect, useRef } from "react";
import DataTable from 'react-data-table-component';
import "react-data-table-component-extensions/dist/index.css";
import { Link, useLocation } from 'react-router-dom';

import { api_crud_route, api_crud_base, api_list_route, endpoints } from './Config';

import { reqGET, reqDELETE, reqPOST } from '../../../Utils';
import { getTokenInfo } from '../../../UseToken';
import UseSidebar from '../../../UseSidebar';

import Loader from '../../Loader/Loader';

//import ProgressBar from '../../Assec/ProgressBar'

import Swal from 'sweetalert2'

import uniqid from 'uniqid';

import { language } from './Language';
//import { roundToNearestMinutes } from "date-fns";
//import { el } from "date-fns/locale";

export default function List() {

    const [data, setData] = useState([])
    const [percentagem, setPercentagem] = useState([])
    //const [, setData_2] = useState([])
    const data2 = useRef([]);
    const [refresh, setRefresh] = useState(0);
    const [isloading, setLoading] = useState(true)

	const [lang, set_lang] = useState('pt');

    const { pathname } = useLocation();
    const [, set_sidebar] = useState([])
    const [permissions, set_permissions] = useState({})

    let get_permissions = (e, sidebar) => {
        let handleSingleCheck = (e, sidebar) => {
            const name = e;

            let ver_submenu = (node) => {
                if (node.submenu.length !== 0) {

                    node.submenu.forEach(subitem => {

                        if (subitem.path === name) {
                            set_permissions({ edit: subitem.edit, gest: subitem.gest, view: true, remove: subitem.remove })
                        }
                        else {
                            ver_submenu(subitem)
                        }

                    })
                }
            }

            sidebar.forEach(node => {
                if(node.path === name && 0) {
                    set_permissions({ edit: node.edit, gest: node.gest, view: true, remove: node.remove })
                } else
                    ver_submenu(node)
            })
        }

        handleSingleCheck(e, sidebar)
    }

    useEffect(() => {


        let fetchApi = async () => {
            set_lang(localStorage.getItem('lang'))
    
            data2.current = []
            setData([]);
   
            if('trainee_user' === getTokenInfo().profile) {
                return await reqGET(`${api_crud_base}/formation/course/search/trainee/${getTokenInfo().companycode}/${getTokenInfo().id}`)
                    //return await reqGET(`${api_list_route(getTokenInfo().companycode)}`)
                    .then(res => {
                                
                        let array_aux = []
                        let date_today = new Date().toJSON().split('T')[0];

                        res.data.forEach(el => {

                            //console.log(el)

                            let date_end = el.info.date.end.split('T')[0];

                            if(date_end !== '' && date_today >= date_end){

                                if(el.content[0]['trainees'] !== undefined) {
                                    let aux = el.content[0]['trainees'].filter(el_2 => el_2.trainee_id === getTokenInfo().id)
                                    if(aux.length > 0) {
                                        //console.log('Dias desde que terminou o curso: ', ((new Date().getTime() - new Date(el.info.date.end).getTime()) / (1000 * 3600 * 24)).toFixed(0))
                                        array_aux.push(el)
                                    }
                                }
                            }
                                
                            
                        })
                        setData(array_aux)
        
                        //setData_2(array_aux)
                        setLoading(false)
                    })
                    .catch(() => 404
                        //  TODO: ENVIAR PÁGINA 404
                        //alert(error)); 
                    )
            }
            else if('trainer_user' === getTokenInfo().profile) {
                return await reqGET(`${api_crud_base}/formation/course/search/trainer/${getTokenInfo().companycode}/${getTokenInfo().id}`)
                    //return await reqGET(`${api_list_route(getTokenInfo().companycode)}`)
                    .then(res => {
        
                    if('trainer_user' === getTokenInfo().profile) {
                            
                            res.data.forEach(v2 => {
                                v2.info.trainers.forEach(v3 =>{
                                    if((v3.id === getTokenInfo().id)){
                                        data2.current.push(v2)
                                        setData([...data2.current]); 
                                        setRefresh(r => r + 1)
                                        //setRefresh(refresh + 1)
        
                                    }
                                }) 
                            })
                        }
                        //setData(res.data)
        
                        setLoading(false)
                    })
                    .catch(() => 404
                        //  TODO: ENVIAR PÁGINA 404
                        //alert(error)); 
                    )
            }
            else {
                return await reqGET(`${api_list_route(getTokenInfo().companycode)}`)
                    .then(res => {

                        res.data.forEach(v2 => {

                            let date_today = new Date().toJSON().split('T')[0];

                            let date_end = v2.info.date.end.split('T')[0];

                            if(date_end !== '' && date_today >= date_end) {
                                data2.current.push(v2)
                                setData([...data2.current]);
                                //setRefresh(r => r + 1)

                            }
                       })

                        setLoading(false)
                    })
                    .catch(() => 404
                        //  TODO: ENVIAR PÁGINA 404
                        //alert(error)); 
                    )
                }
        }

        const coursesStatus = async () => {
            if('trainee_user' === getTokenInfo().profile) {
                return reqGET(`${api_crud_base}/formation/course/search/trainee/${getTokenInfo().companycode}/${getTokenInfo().id}`)
                    
                    .then(res => {
                        //let array_aux = []
                        let y = percentagem
                        //let percentagem_aux = 0
                        //let sum = 0
                        res.data.forEach(el => {
                            if(el.content[0]['modules'] !== undefined && el.content[0]['modules'] !== null) {

                                let sum = 0
                                //let x = el.content[0]['trainees'].filter(el_2 => el_2.trainee_id === getTokenInfo().id)
    
                                //console.log('array trainees: ', x)
                                //if(x.length > 0){
                                    //array_aux.push(el)
                                    el.content[0].modules.forEach(k => {
    
                                        //console.log(console.log('array modules: ', k))
                                        if(k.trainees !== undefined && k.trainees !== null) {

                                            let trainee_aux = k['trainees'].filter(el_2 => el_2.trainee_id === getTokenInfo().id)
                                            trainee_aux.forEach(v => {
                                                //console.log('array module trainees: ', v)
                                                //console.log('avaliação trainee: ', v.trainee_module_evaluation)

                                                if(v.trainee_module_evaluation !== undefined && v.trainee_module_evaluation !== ''){
                                                    sum ++;
                                                    //console.log('SOMA 1', sum)
                                                }
                                            })
                                        }
                                    })
    
                                    //console.log(el.id)
                                    //console.log('soma final: ', sum)
                                    //console.log('modules length: ', el.content[0].modules.length)
                                    y[el.id] = (sum * 100) / el.content[0].modules.length
                                    setPercentagem(y)
    
                                    //console.log('PERCENTAGEM', percentagem)
                                    
    
                                //}
                            }
                        })     
                        setLoading(false)
                    })
                    .catch(() => 404
                        //  TODO: ENVIAR PÁGINA 404
                        //alert(error)); 
                    )
    
            }
        }

        fetchApi()  
        coursesStatus()
        
        UseSidebar().getSidebar(getTokenInfo().profile)
            .then(v => {
                get_permissions(pathname, v)
                set_sidebar(v)
                //setLoading(false)
            }); 
    }, [pathname, percentagem, refresh]);

    //APAGAR REGISTO
    function apagar(id) {

        Swal.fire({
			title: language[lang].delete_title,
			text: language[lang].delete_text,
			icon: 'question',
			showCancelButton: true,
			confirmButtonColor: '#0095e8',
			cancelButtonColor: '#d9214e',
			confirmButtonText: language[lang].delete_confirm,
			cancelButtonText: language[lang].delete_cancel
		})
		.then((result) => {
			if (result.isConfirmed) {
				reqDELETE(api_crud_route, { id: id })
					.then(res => {
						//props.history.push(endpoints.list);
					})
					.catch(error => console.log(error))
			}
		})

    }

    //DUPLICAR REGISTO
    function duplicateFormation(row) {

        console.log('Registo original ', row)

        var today_submit = new Date().toJSON()

        let aux_clone_row = []

        aux_clone_row = JSON.parse(JSON.stringify(row))

        if(aux_clone_row.info.trainers !== undefined && aux_clone_row.info.trainers.length > 0) {

            aux_clone_row.info.trainers = []

        }

        if(aux_clone_row.info.date.modified !== undefined && aux_clone_row.info.date.modified.length > 0) {

            aux_clone_row.info.date.modified = []

        }

        if(aux_clone_row.content[0].candidates !== undefined && aux_clone_row.content[0].candidates.length > 0) {

            aux_clone_row.content[0].candidates = []

        }

        if(aux_clone_row.content[0].trainees !== undefined && aux_clone_row.content[0].trainees.length > 0) {

            aux_clone_row.content[0].trainees = []

        }

        if(aux_clone_row.content[0].media.doc !== undefined && aux_clone_row.content[0].media.doc.length > 0) {

            aux_clone_row.content[0].media.doc = []

        }

        if(aux_clone_row.content[0].media.image !== undefined && aux_clone_row.content[0].media.image.length > 0) {

            aux_clone_row.content[0].media.image = []

        }

        if(aux_clone_row.content[0].modules !== undefined && aux_clone_row.content[0].modules.length > 0) {

            aux_clone_row.content[0].modules.forEach(v => {

                if(v.trainees !== undefined && v.trainees.length > 0) {

                    v.trainees = []
        
                }

                if(v.trainer !== undefined && v.trainer !== null && v.trainer !== '') {

                    v.trainer = { 
                        email: '',
                        id:  '',
                        name: '',
                        notified: false,
                        username: ''
                        
                    }
        
                }

                if(v.sessions !== undefined && v.sessions.length > 0){

                    //v.sessions = []
                
                    v.sessions.forEach(v2 => {

                        if(v2.trainees !== undefined && v2.trainees.length > 0) {

                            v2.trainees = []
                
                        }

                        if(v2.uniqid !== undefined && v2.uniqid !== '') {

                            let uid = uniqid()

                            //console.log('novo uid da sessão: ', uid)

                            v2.uniqid = uid
                
                        }

                    })
                }
           })

        }

        aux_clone_row.id = ''
        aux_clone_row.info.date.creation = today_submit
        aux_clone_row.info.name = (aux_clone_row.info.name + ' (duplicado)')
        aux_clone_row.content[0].title = (aux_clone_row.content[0].title + ' (duplicado)')

        console.log('Registo duplicado e modificado ', aux_clone_row)

        Swal.fire({
			title: language[lang].duplicate_title,
			text: language[lang].duplicate_text,
			icon: 'question',
			showCancelButton: true,
			confirmButtonColor: '#0095e8',
			cancelButtonColor: '#d9214e',
			confirmButtonText: language[lang].duplicate_confirm,
			cancelButtonText: language[lang].duplicate_cancel
		})
        .then((result) => {
            if (result.isConfirmed) {
                reqPOST(api_crud_route, aux_clone_row)
                    .then(() => { 

                        setRefresh(refresh + 1)

                        //window.location.reload()

                        //props.history.push(endpoints.list) 
                    })
                    .catch(() => Swal.fire(language[lang].duplicate_error, '', 'info'))
            }
        })

    }

    const columns = [
        {
            name: language[lang].name,
            selector: 'info.name',
            cell: row => <div>{row.content[0].title}</div>,
            width: '40%',
            minWidth: '30% !important',
            sortable: true,
            left: true,
        },
        {
            name: language[lang].table_date_begin,
            selector: 'info.date.begin',
            cell: row => {
                let date = new Date(row.info.date.begin); 

                if(row.info.date.begin !== '') {
                
                    return date.getDate().toString().padStart(2, '0') + '/' + (date.getMonth() + 1).toString().padStart(2, '0') + '/' + date.getFullYear()
               
                } else {

                    return ''

                }
            },
            width: '10%',
            minWidth: '110px !important',
            sortable: true,
            center: true,
        },
        {
            name: language[lang].table_date_end,
            selector: 'info.date.end',
            cell: row => {
                let date = new Date(row.info.date.end); 

                if(row.info.date.end !== '') {
                
                    return date.getDate().toString().padStart(2, '0') + '/' + (date.getMonth() + 1).toString().padStart(2, '0') + '/' + date.getFullYear()
               
                } else {

                    return ''

                }
            },
            width: '10%',
            minWidth: '110px !important',
            sortable: true,
            center: true,
        },
        {
            name: language[lang].table_state,
            selector: 'title',
            cell: row => {
                 //console.log('ROWWWWW', row)
                 //console.log('P', percentagem)

                /*let p = percentagem[row.id]
                
                return (
                    <>                        
                        {Math.trunc(p)}%

                        <br />

                        <ProgressBar percentagem={p}/>  
                    </>               
                )*/

                return (
                    <span className={"badge rounded-pill fw-normal bg-success"}>
                        {language[lang].state_ended}
                    </span>
                )
            },
            width: '10%',
            minWidth: '82px !important',
            sortable: false,
            center: true,
        },
        {
            name: language[lang].certificate,
            selector: 'certificate',
            cell: row => {
                 //console.log('ROWWWWW', row)

                 let auxCertificate = []
                 if(row.content[0].trainees[0].files !== undefined && row.content[0].trainees[0].files.length > 0) {

                    row.content[0].trainees[0].files.forEach(v => {

                        auxCertificate.push(v)

                    })

                 }

                 if(auxCertificate.length > 0){
                    return (
                        <div>
                            <a href={auxCertificate[0].link} alt={auxCertificate[0].name} title={auxCertificate[0].name} target='_blank' rel="noreferrer">
                                <i className="bi bi-file-pdf me-2"></i>
                                {/*auxCertificate[0].name*/}
                                {language[lang].certificate_view}
                            </a>
                        </div>
                    )
                 }
            },
            width: '20%',
            minWidth: '82px !important',
            sortable: false,
            center: true,
        },
        {
            name: '',
            right: true,
            export: false,
            print: false,
            width: '10%',
            minWidth: '100px !important',
            cell: row =>
                <span>
                    {
                        //passados 15 dias da conclusão do curso o formando já não pode aceder à view da formação
                        ('trainee_user' === getTokenInfo().profile) && (((new Date().getTime() - new Date(row.info.date.end).getTime()) / (1000 * 3600 * 24)).toFixed(0) <= 15) ?
                            <Link className="button button-update button-view" to={{ pathname: endpoints.view, state: { item: row, operation: 'edit', return_button_endpoint: 'list2' } }} >
                                <i className="bi bi-eye"></i>
                                <span className="tooltiptext">{language[lang].view}</span>
                            </Link>
                         :
                         null
                    }

                    {
                    permissions.edit ?
                        <Link className={permissions.edit ? "button button-update" : "d-none" } to={{ pathname: endpoints.regist, state: { item: row, operation: 'edit' } }} >
                            <i className="bi bi-pencil"></i>
                            <span className="tooltiptext">{language[lang].edit}</span>
                        </Link>
                    :
                        null
                    }

                    {
                    permissions.gest ?
                        <Link className={permissions.gest ? "button button-gest" : "d-none" } to={{ pathname: endpoints.gest, state: { item: row, operation: 'edit' } }} >
                            <i className="bi bi-gear"></i>
                            <span className="tooltiptext">{language[lang].gest}</span>
                        </Link>
                    :
                        null
                    }

                    {
                    permissions.remove ?
                        <button className={permissions.remove ? "button button-delete d-none" : "d-none" } onClick={() => apagar(row['id'])}>
                            <i className="bi bi-trash"></i>
                            <span className="tooltiptext">{language[lang].delete}</span>
                        </button>
                    :
                        null
                    }
                </span>
        },
    ];

    const columns2 = [
        {
            name: language[lang].name,
            selector: 'info.name',
            cell: row => <div>{row.content[0].title}</div>,
            width: '40%',
            minWidth: '30% !important',
            sortable: true,
            left: true,
        },
        /*{
            name: language[lang].table_date,
            selector: 'info.date.creation',
            cell: row => {
                let date = new Date(row.info.date.creation); 
                
                return date.getDate().toString().padStart(2, '0') + '/' + (date.getMonth() + 1).toString().padStart(2, '0') + '/' + date.getFullYear()
            },
            width: '10%',
            minWidth: '110px !important',
            sortable: true,
            center: true,
        },*/
        {
            name: language[lang].table_date_begin,
            selector: 'info.date.begin',
            cell: row => {
                let date = new Date(row.info.date.begin); 

                if(row.info.date.begin !== '') {
                
                    return date.getDate().toString().padStart(2, '0') + '/' + (date.getMonth() + 1).toString().padStart(2, '0') + '/' + date.getFullYear()
               
                } else {

                    return ''

                }
            },
            width: '10%',
            minWidth: '110px !important',
            sortable: true,
            center: true,
        },
        {
            name: language[lang].table_date_end,
            selector: 'info.date.end',
            cell: row => {
                let date = new Date(row.info.date.end); 

                if(row.info.date.end !== '') {
                
                    return date.getDate().toString().padStart(2, '0') + '/' + (date.getMonth() + 1).toString().padStart(2, '0') + '/' + date.getFullYear()
               
                } else {

                    return ''

                }
            },
            width: '10%',
            minWidth: '110px !important',
            sortable: true,
            center: true,
        },
        {
            name: language[lang].table_state,
            selector: 'title',
            cell: row => {
                let date_today = new Date().toJSON().split('T')[0];

                var date_begin = row.info.date.begin.split('T')[0];
                var date_end = row.info.date.end.split('T')[0];

                let status = 0

                //console.log('Data de fim:', date_end)

                if((date_begin !== '' && date_today >= date_begin && (date_today <= date_end || date_end === ''))) 
                    //curso em desenvolvimento
                    status = 1

                if(date_end !== '' && date_today > date_end)
                    //curso terminado
                    status = 2

                if(date_today < date_begin)
                    //curso por iniciar
                    status = 3
                
                return (
                    <span className={status === 2 ? "badge rounded-pill fw-normal bg-success" : (status === 1 ? "badge rounded-pill fw-normal bg-warning" : "badge rounded-pill fw-normal bg-primary")}>
                        {status === 2 ? language[lang].state_ended : (status === 1 ? language[lang].state_open : language[lang].state_to_start)}
                    </span>
                )
            },
            width: '10%',
            minWidth: '82px !important',
            sortable: false,
            center: true,
        },
        {
            name: '',
            right: true,
            export: false,
            print: false,
            width: '20%',
            minWidth: '100px !important',
            cell: row =>
                <span>
                    <Link className="button button-update button-view d-none" to={{ pathname: endpoints.view, state: { item: row, operation: 'edit', return_button_endpoint: 'list2' } }} >
                        <i className="bi bi-eye"></i>
                        <span className="tooltiptext">{language[lang].view}</span>
                    </Link>

                    {
                    permissions.edit ?
                        <Link className={permissions.edit ? "button button-update" : "d-none" } to={{ pathname: endpoints.regist, state: { item: row, operation: 'edit', return_button_endpoint: 'list2' } }} >
                            <i className="bi bi-pencil"></i>
                            <span className="tooltiptext">{language[lang].edit}</span>
                        </Link>
                    :
                        null
                    }

                    {
                    permissions.gest ?
                        <Link className={permissions.gest ? "button button-gest" : "d-none" } to={{ pathname: endpoints.gest, state: { item: row, operation: 'edit', return_button_endpoint: 'list2' } }} >
                            <i className="bi bi-gear"></i>
                            <span className="tooltiptext">{language[lang].gest}</span>
                        </Link>
                    :
                        null
                    }

                    {
                        (getTokenInfo().profile === 'Gestor de formações' || getTokenInfo().profile === 'Administrador') ?

                            <button className={"button button-duplicate"} onClick={() => duplicateFormation(row)} >
                                <i className="bi bi-files"></i>
                                <span className="tooltiptext">{language[lang].duplicate_title}</span>
                            </button>
                        :
                            null 
                    }

                    {
                    permissions.remove ?
                        <button className={permissions.remove ? "button button-delete d-none" : "d-none" } onClick={() => apagar(row['id'])}>
                            <i className="bi bi-trash"></i>
                            <span className="tooltiptext">{language[lang].delete}</span>
                        </button>
                    :
                        null
                    }
                </span>
        },
    ];
    
    const defaultComponentOptions = {
        rowsPerPageText: language[lang].table_rows_per_page,
        rangeSeparatorText: language[lang].table_separator,
        noRowsPerPage: false,
        selectAllRowsItem: false,
        selectAllRowsItemText: language[lang].table_all,
    };

    return (isloading ?
        
        <Loader />

        :

        <main>
            <div className={`dash-cards header`}>
                <h2 className="dash-title">{language[lang].content_list}</h2>
                <p>{language[lang].content} / {language[lang].content_list}</p>
            </div>
                
            <div className={`dash-cards body`}>
                <div className="container">

                    <div className="card mb-5">
                        <div className="card-body">
                            <div className="pb-10 ">
                                <div className="div-table">
                                    <div className={"table-header text-end mb-5" + (getTokenInfo().profile === 'trainee_user' ? ' d-none' : '')}>
                                        <Link className="btn btn-sm btn-secondary rounded-0 multi-item" to={{ pathname: endpoints.regist }}  >
                                            <img className="me-2" alt={language[lang].add_new} title={language[lang].add_new} src={'./img/plus.svg'} />
                                            <span>{language[lang].add_new}</span>
                                        </Link>
                                    </div>
                                    {
                                        ('trainee_user' === getTokenInfo().profile && data.length > 0) ?
                                            <div className="mb-3 position-relative">
                                                {/*<label className="col-form-label fs-6 fw-bold">{language[lang].notice}&#58;</label>
                                                <p>{language[lang].notice_message}</p>*/}
                                                <button type='button' className='info'>
                                                    <i className="bi bi-info-square text-info fs-4" /*title={language[lang].notice_message}*/></i>
                                                    <span className="tooltiptext text-start">{language[lang].notice_message}</span>
                                                </button>
                                                
                                            </div>
                                        : null
                                    }
                                    
                                    <div className="table-body">

                                        {('trainee_user' === getTokenInfo().profile) ?
                                            <DataTable
                                                columns={columns}
                                                data={data}
                                                noDataComponent={language[lang].table_empty}
                                                noHeader
                                                pagination
                                                exportHeaders
                                                paginationComponentOptions={defaultComponentOptions}
                                                paginationPerPage={25}
                                                paginationRowsPerPageOptions={[25, 50, 100]}
                                            />
                                        :
                                            <DataTable
                                                columns={columns2}
                                                data={data}
                                                noDataComponent={language[lang].table_empty}
                                                noHeader
                                                pagination
                                                exportHeaders
                                                paginationComponentOptions={defaultComponentOptions}
                                                paginationPerPage={25}
                                                paginationRowsPerPageOptions={[25, 50, 100]}
                                            />
                                        }
                                        
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>

                </div>
            </div>
        </main>
    )
}